import { useSelector } from 'react-redux';
import { MONTHLY } from 'self-service-api/constants/Terms';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { CALCULATOR } from 'pricing-pages-lib/constants/PurchaseMotionsLocations';
import { APP } from '../../constants/AuthType';
import Screens from '../../constants/routing/Screens';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import { hasProductsSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { currentSkuIdForProductSelector, upgradeProductSelector } from '../../selectors/ProductsSelectors';
import { purchaseMotionsSelector } from '../../selectors/PurchaseMotionSelectors';
import CodeSplitEnvWrapper from '../common/env/CodeSplitEnvWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const CompareCTA = ({
  apiName
}) => {
  const hasProductsSucceeded = useSelector(hasProductsSucceededSelector);
  const currencyCode = useSelector(activeCurrencySelector);
  const skuId = useSelector(state => {
    if (!hasProductsSucceeded) return null;
    return currentSkuIdForProductSelector(state, {
      apiName
    });
  });
  const upgradeProduct = useSelector(state => {
    return upgradeProductSelector(state, {
      skuIds: [skuId]
    });
  });
  const purchaseMotions = useSelector(state => purchaseMotionsSelector(state, {
    location: CALCULATOR,
    skuId
  }));
  const productConfigurations = [createProductConfig({
    skuId
  })];
  const screen = Screens.COMPARE;
  const sourceId = 'compare-table';
  const upgradeData = {
    app: APP,
    screen,
    upgradeProduct,
    uniqueId: `${screen}-${upgradeProduct}`
  };
  return /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
    authedComponentLoader: () => import( /* webpackChunkName: "authed-chunk" */`pricing-pages-ui/components/common/purchaseMotions/PurchaseMotionButtonWrapper`),
    publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */`pricing-pages-ui/components/common/purchaseMotions/PublicPurchaseMotionButton`),
    authedComponentProps: {
      use: 'primary',
      level: 1,
      productConfigurations,
      purchaseMotions,
      currencyCode,
      trackingSource: sourceId,
      queryParamTerm: MONTHLY,
      upgradeData,
      style: {},
      filterOwnedMarketingProducts: false
    },
    publicComponentProps: {
      use: 'primary',
      productConfigurations,
      purchaseMotions,
      sourceId,
      trackingSource: sourceId,
      numPurchaseMotions: 1,
      maxNumPurchaseMotions: 1,
      queryParamTerm: MONTHLY,
      style: {}
    }
  });
};
export default CompareCTA;